import { SVG } from 'components/HeadlessCMS/svg';
import React, { useState } from 'react';
import './carousal.scss';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from 'reactstrap';
import { toast } from 'react-toastify';
import Axios from 'functions/Axios';
import { CMS_API_URL } from 'Constant';
import { saveAs } from 'file-saver';

type Props = {
  className?: string;
  children: React.ReactNode;
  items: any;
  isSlider: boolean;
  disabled: boolean;
  click: (e: any) => void;
  item: any;
};

export const CarousalC: React.FC<Props> = ({
  className,
  children,
  items,
  disabled,
  isSlider = true,
  click = () => {},
  item,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [animating, setAnimating] = useState<Boolean>(false);
  const copyToClipboard = () => {
    navigator.clipboard.writeText(items[activeIndex].filePath);
    toast.success('Link copied to clipboard!');
  };
  const downloadImage = async () => {
    const url = items[activeIndex]; // Assuming items and activeIndex are defined in your component state

    try {
      const response = await Axios.post(
        `${CMS_API_URL}/media/download/${url.id}`,
        {},
        {
          responseType: 'blob', // Ensures the response is returned as a blob
        },
      );

      // Create a filename based on the altText or default to 'image'
      const fileName = url.altText ? `${url.altText}.jpg` : 'image.jpg';

      // Use saveAs from the file-saver library to download the image
      saveAs(response.data, fileName);
    } catch (error) {
      console.error('Error downloading the image:', error);
    }
  };

  const Indicators = () => {
    return (
      <div className="Ecollat_indicators" style={{ opacity: disabled ? 0.6 : 1 }}>
        <div className="indicator_buttons">
          <div
            className="indicator_box"
            onClick={() => {
              if (disabled) return;
              copyToClipboard();
            }}
          >
            {SVG.copy}
          </div>
          <div
            className="indicator_box"
            onClick={() => {
              if (disabled) return;
              downloadImage();
            }}
          >
            {SVG.Download}
          </div>
          <div
            className="indicator_box"
            onClick={() => {
              if (disabled) {
                return;
              }
              click(item);
            }}
          >
            {SVG.edit}
          </div>
        </div>
      </div>
    );
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const slides = items.map((item: any) => {
    if (!isSlider) {
      return (
        <div
          className="d-flex justify-content-center"
          style={{
            height: '100%',
            maxHeight: '25rem',
            width: '100%',
            objectFit: 'contain',
            background: 'var(--background)',
          }}
          key={item.src}
        >
          <img
            src={item.src}
            alt={item.src}
            style={{ height: '100%', width: '100%', objectFit: 'contain' }}
          />
        </div>
      );
    }

    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img
          src={item.src}
          style={{
            height: '100px',
            width: '100%',
            objectFit: 'contain',
          }}
          alt={item.altText}
        />
      </CarouselItem>
    );
  });

  return (
    <Carousel className={className} activeIndex={activeIndex} next={next} previous={previous}>
      <Indicators />
      {/* <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} /> */}

      {slides}
      {items.length > 1 && (
        <>
          <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
          <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
        </>
      )}
    </Carousel>
  );
};
